$(function () {
  // swiper
  let thumbSwiper = new Swiper('#product_swiper_thumb', {
    slidesPerView: 4.5,
    spaceBetween: 8,
    breakpoints: {
      750: {
        slidesPerView: 6.5,
        spaceBetween: 12,
      },
    },
  });
  let mainSwiper = new Swiper('#product_swiper', {
    centeredSlides: true,
    slidesPerView: 1,
    thumbs: {
      swiper: thumbSwiper,
      autoScrollOffset: 2,
    },
  });

  // selectの組み合わせを番号にして配列に挿入
  const $productSelect = $('.js_product_select');
  let productSelectValueArray = [];
  $productSelect
    .eq(0)
    .children('option')
    .each(function (i) {
      $productSelect
        .eq(1)
        .children('option')
        .each(function (j) {
          $productSelect
            .eq(2)
            .children('option')
            .each(function (k) {
              productSelectValueArray.push(String(i) + String(j) + String(k));
            });
        });
    });

  // selectedの結合したindex番号が入る変数
  let productSelectedValue = '';
  changeSelect();
  $productSelect.on('change', function () {
    productSelectedValue = '';
    changeSelect();
  });
  // selectedの値が変わった際に発火
  function changeSelect() {
    // selectで選択されているindex番号を結合して変数へ入れる
    $productSelect.each(function () {
      productSelectedValue += String($(this).children('option:selected').index());
    });
    changeMainSelect();
  }
  // select変更時にメインのselectの値を変更
  function changeMainSelect() {
    $.each(productSelectValueArray, function (i, v) {
      if (v === productSelectedValue) {
        $('.js_product_variants').find('option').eq(i).prop('selected', true);
        changePrice();
      }
    });
  }
  // select変更時の値段変更
  function changePrice() {
    const variantsPrice = $('.js_product_variants option:selected').attr('data-price');
    $('#product_form_price_num').text(variantsPrice);
  }

  // spの購入ボタン表示非表示
  const $cartAddBtn = $('#product_form_add_btn');
  let cartAddBtnTimer;
  $(window).on('scroll', function () {
    $cartAddBtn.removeClass('product_form_add_btn_active');
    clearTimeout(cartAddBtnTimer);
    cartAddBtnTimer = setTimeout(function () {
      $cartAddBtn.addClass('product_form_add_btn_active');
    }, 200);
  });

  // spのパネルサイズ切り替え
  const $panelSizeRadio = $('input[name="panel_size"]');
  panelSizeChange();
  $panelSizeRadio.on('change', function () {
    panelSizeChange();
  });
  function panelSizeChange() {
    const panelSizeData = $('input[name="panel_size"]:checked').attr('data-size');
    $('#panel_size_sp_img_size img').hide();
    $('#panel_size_sp_img_size')
      .find('img[size="' + panelSizeData + '"]')
      .show();
  }
});
